class StyleX {

  /**
   * 
   * @param {import("react").CSSProperties} style 
   * @returns 
   */
  static CSS(style){
    return style;
  }

}

export default StyleX;